//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    title: {
      type: String,
      default: 'A different approach',
    },
    content: {},
    arrow: {
      type: String,
      default: '',
    },
    arrowUrl: {
      type: String,
      default: '',
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/IntroBanner.vue